import { useMutation, useQuery } from '@tanstack/react-query'
import { adminApi } from '../services/adminApi'
import type { GetUsersParams } from '../types/admin'

export const adminKeys = {
  all: ['admin'] as const,
  users: () => [...adminKeys.all, 'users'] as const,
  userList: (params?: GetUsersParams) => [...adminKeys.users(), params] as const,
  userStats: () => [...adminKeys.all, 'user-stats'] as const,
  userDetail: (id: number) => [...adminKeys.users(), 'detail', id] as const,
}

export function useAdminUsers(params: GetUsersParams = {}) {
  return useQuery({
    queryKey: adminKeys.userList(params),
    queryFn: () => adminApi.getUsers(params),
  })
}

export function useAdminUserStats() {
  return useQuery({
    queryKey: adminKeys.userStats(),
    queryFn: () => adminApi.getUserStats(),
  })
}

export function useAdminUserDetail(id: number) {
  return useQuery({
    queryKey: adminKeys.userDetail(id),
    queryFn: () => adminApi.getUserDetail(id),
    enabled: id > 0,
  })
}

export function useImpersonateUser() {
  return useMutation({
    mutationFn: (userId: number) => adminApi.impersonateUser(userId),
  })
}
